/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_AccionAsync as AccionAsync,
  rec_B0 as B0,
  rec_BuscarConversacion as BuscarConversacion,
  rec_Componente_s3_115_51 as Componente_s3_115_51,
  rec_F0 as F0,
  rec_FotoPuesto as FotoPuesto,
  rec_Go as Go,
  rec_H0 as H0,
  rec_JSXRuntime as JSXRuntime,
  rec_L0 as L0,
  rec_Lo as Lo,
  rec_M0 as M0,
  rec_MarcaCarga as MarcaCarga,
  rec_Modal as Modal,
  rec_React as React,
  rec_SelectorMultiple as SelectorMultiple,
  rec_api as api,
  rec_h0 as h0,
  rec_z0 as z0,
} from "../../runtime/index.jsx";
export function FormularioPuesto({
  fila: e,
  subgrupos: t,
  jefes: n,
  onCerrar: r,
  onGuardado: i,
  onActualizada: a,
}) {
  let o = Go(),
    [s, c] = (0, React.useState)(e),
    [l, u] = (0, React.useState)(() => L0(e)),
    [f, p] = (0, React.useState)(!e || e.activo),
    [m, h] = (0, React.useState)(null),
    [g, _] = (0, React.useState)(``),
    v = !e,
    y = e?.id,
    b = e?.version,
    x = e ? (e.apenom ?? `Puesto vacante`) : `Nuevo puesto`,
    S = e?.alertas ?? [];
  function C(e, t) {
    u((n) => ({
      ...n,
      [e]: t,
    }));
  }
  async function w(e) {
    h(null);
    let t = (e ?? ``).trim();
    if (/^\d{7,12}$/.test(t))
      try {
        h(
          await api(`/organigrama/nisira/${encodeURIComponent(t)}`, {
            sinCache: !0,
          }),
        );
      } catch (e) {
        h({
          noEsta: !0,
          mensaje: e.message,
        });
      }
  }
  async function T() {
    _(``);
    try {
      let e = v
        ? await api(`/organigrama`, {
            method: `POST`,
            body: JSON.stringify(l),
          })
        : await api(`/organigrama/${y}`, {
            method: `PUT`,
            body: JSON.stringify({
              version: b,
              activo: f,
              datos: l,
            }),
          });
      (o.ok(v ? `Puesto creado` : `Puesto guardado`), i(e));
    } catch (e) {
      _(e.message);
    }
  }
  let E = (e, t) => (
    <label
      key={e}
      className={`flex flex-col gap-1 text-xs text-(--text)`}
      children={[
        t,
        <input
          className={`${Lo} min-h-11 uppercase`}
          value={l[e] ?? ``}
          maxLength={200}
          onChange={(t) => C(e, t.target.value)}
        />,
      ]}
    />
  );
  return (
    <Modal
      titulo={x}
      onClose={r}
      ancho={`max-w-2xl`}
      children={
        <div
          className={`flex flex-col gap-4`}
          children={[
            s?.dni && !s.vacante && (
              <FotoPuesto
                fila={s}
                onCambio={(e) => {
                  (c(e), a?.(e));
                }}
              />
            ),
            S.length > 0 && <Componente_s3_115_51 alertas={S} />,
            <section
              className={`flex flex-col gap-3`}
              children={[
                <h3
                  className={`text-sm font-medium text-(--text-h) !m-0`}
                  children={`Se escribe acá`}
                />,
                <div
                  className={`grid gap-3 sm:grid-cols-2`}
                  children={[
                    <label
                      className={`flex flex-col gap-1 text-xs text-(--text)`}
                      children={[
                        `DNI (vacío si el puesto está vacante)`,
                        <input
                          className={`${Lo} min-h-11`}
                          inputMode={`numeric`}
                          value={l.dni ?? ``}
                          maxLength={12}
                          onChange={(e) => C(`dni`, e.target.value)}
                          onBlur={(e) => w(e.target.value)}
                        />,
                        m &&
                          (m.noEsta ? (
                            <span
                              className={`text-(--warning-texto)`}
                              children={m.mensaje}
                            />
                          ) : (
                            <span
                              className={`text-(--text-h)`}
                              children={[
                                m.apenom,
                                ` · `,
                                m.cargo,
                                m.cesado ? ` · cesado` : ``,
                              ]}
                            />
                          )),
                      ]}
                    />,
                    E(`cargoCorrecto`, `Cargo correcto`),
                    E(`gerenciaCorporativa`, `Gerencia corporativa`),
                    E(`gerenciaLinea`, `Gerencia de línea`),
                    E(`area`, `Área`),
                    E(`seccion`, `Sección`),
                    <div
                      className={`flex flex-col gap-1 text-xs text-(--text)`}
                      children={[
                        `Subgrupo de trabajo`,
                        <SelectorMultiple
                          value={l.subgrupoTrabajo ?? ``}
                          onChange={(e) => C(`subgrupoTrabajo`, e || null)}
                          placeholder={`(Sin subgrupo)`}
                          opciones={t.filter((e) => e.value)}
                        />,
                      ]}
                    />,
                    <div
                      className={`flex flex-col gap-1 text-xs text-(--text)`}
                      children={[
                        `Jefe inmediato`,
                        <BuscarConversacion
                          value={z0(l)}
                          onChange={(e) => u((t) => B0(t, e))}
                          opciones={n.filter(
                            (e) =>
                              e.value !== l.dni && (!y || e.puestoId !== y),
                          )}
                          extra={H0}
                          placeholder={`Buscá al jefe por nombre, cargo vacante o DNI…`}
                        />,
                      ]}
                    />,
                    E(`cultivo`, `Cultivo`),
                    E(`sede`, `Sede`),
                    E(`perfiles`, `Perfiles`),
                    E(`control`, `Control`),
                  ]}
                />,
                !v && (
                  <MarcaCarga
                    checked={f}
                    onChange={p}
                    children={`Puesto activo`}
                  />
                ),
              ]}
            />,
            e && (
              <section
                className={`flex flex-col gap-2`}
                children={[
                  <h3
                    className={`text-sm font-medium text-(--text-h) !m-0`}
                    children={`De NISIRA y calculado`}
                  />,
                  <dl
                    className={`grid gap-x-4 gap-y-2 text-sm sm:grid-cols-2`}
                    children={F0.filter(
                      (e) => e.origen !== M0.MANUAL && e.clave !== `alertas`,
                    ).map((t) => (
                      <div
                        key={t.clave}
                        className={`min-w-0`}
                        children={[
                          <dt
                            className={`text-xs text-(--text)`}
                            children={t.titulo}
                          />,
                          <dd
                            className={`break-words text-(--text-h)`}
                            children={h0(e, t) || `—`}
                          />,
                        ]}
                      />
                    ))}
                  />,
                ]}
              />
            ),
            g && <p className={`text-sm text-(--error-texto)`} children={g} />,
            <div
              className={`flex justify-end gap-2`}
              children={[
                <AccionAsync
                  variante={`secundario`}
                  className={`min-h-11`}
                  onClick={r}
                  children={`Cancelar`}
                />,
                <AccionAsync
                  className={`min-h-11`}
                  onClick={T}
                  children={v ? `Crear puesto` : `Guardar`}
                />,
              ]}
            />,
          ]}
        />
      }
    />
  );
}
